import { lazy } from 'react';

export const AuthSignInScreenLazy = lazy(async () => {
  const { AuthSignInScreen } = await import('./auth-sign-in.screen.tsx');
  return { default: AuthSignInScreen };
});
